import React from "react";
import clsx from "clsx";

type TButton = {
  label: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  buttonId?: string;
};

export const Button = ({
  label,
  className,
  onClick,
  disabled,
  buttonId,
}: TButton) => {
  return (
    <button
      id={buttonId}
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        "rounded-[8px] border-[2px] border-primary-300 bg-primary-200 hover:bg-primary-900 hover:scale-105 active:bg-primary-800",
        className
      )}
    >
      <div
        className="py-[8px] px-4 rounded-[7px] border-[1px] border-primary-100 shadow-[0px_-2px_1px_0px_rgba(255,255,255,0.25)_inset,_0px_1px_6px_0px_rgba(0,0,0,0.25)]
      hover:shadow-[inset_0px_2px_1px_0px_rgba(255,255,255,0.25),_0px_1px_6px_0px_rgba(0,0,0,0.25)]"
      >
        <p className="text-primary-400 font-600 text-[13px] md:text-[15px] text-shadow-[0px_1px_1px_rgba(0,0,0,0.25)]">
          {label}
        </p>
      </div>
    </button>
  );
};
